import { esVintagePalette } from "../../../../Posts/02-tonos/15-paletas-vintage/vintagePalettes.js";
import * as React from 'react';
export default {
  esVintagePalette,
  React
};